import { AccountDetails } from "features/types";

export const accountHasTdcAccountLinked = (
  account: AccountDetails | undefined,
  providerTemplateId: number
) => {
  if (!account) return false;
  const eligibleConfigs = account.providerExtUserConfigDetails
    .filter((config) => config.providerTemplateId === providerTemplateId)
    .filter((config) => Object.keys(config.extUserDetails || {}).length > 0); // filter out empty user config details;
  if (eligibleConfigs.length === 0) return false;
  const eligibleConfig = eligibleConfigs[0];
  if (eligibleConfig.extUserDetails == null) return false;
  return (
    "tdcUserId" in eligibleConfig.extUserDetails &&
    "tdcUsername" in eligibleConfig.extUserDetails
  );
};
